export const skills = [
    {
      language: "C++",
      logo: "./cpp.svg",
    },
    {
      language: "Python",
      logo: "./python.svg",
    },
    {
      language: "JavaScript",
      logo: "./javascript.svg",
    },
    {
      language: "Docker",
      logo: "./docker.svg",
    },
    {
      language: "ReactJS",
      logo: "./react.svg",
    },
    {
      language: "NodeJS",
      logo: "./nodejs.svg",
    },
    {
      language: "MySQL",
      logo: "./mysql.svg",
    },
    {
      language: "MongoDB",
      logo: "./mongodb.svg",
    },
    
    {
      language: "Git",
      logo: "./git.svg",
    },
    {
        language: "Postman",
        logo: "./postman.svg",
    },
  ];


// WEBPACK FOOTER //
// ./src/components/Skills/data.js